// @ts-strict-ignore
import { CURRENCY_SIMBOL } from '../constants'

const isEmpty = (value) => value === null || value === '' || value === undefined

export default function FormatCurrency(_value, _currency = 'GBP', _currencyTag = CURRENCY_SIMBOL) {
  if (isEmpty(_value)) return ''
  let value = 0
  if (isNaN(_value)) {
    value = _value
      .toString()
      .replace(_currencyTag, '')
      .replaceAll(',', '')
      .replace(/\D/, '')
      .substring(0, 8)
  } else {
    value = _value
  }
  return new Intl.NumberFormat({ style: 'currency', currency: _currency }).format(value)
}
